import { useState, useEffect } from "react";
import {
  BillingUser,
  BillingUserWithoutCommon,
} from "translations/src/models/billing";
import { getUserGroup } from "shared-auth";
import { AccountTypeBillingTypeMap } from "config/common";
import { useParams } from "react-router-dom";
import { CheckoutType } from "services/applicationMap";

export default function useGetUserType() {
  const memberGroup = getUserGroup();
  const { type } = useParams<{ type: CheckoutType }>();
  const [userType, setUserType] = useState<BillingUserWithoutCommon>();

  useEffect(() => {
    if (type === CheckoutType.Change) {
      return setUserType(BillingUser.PerformerChange);
    }

    if (type === CheckoutType.Graduate) {
      // user will not have graduate member group when entering conversion flow
      return setUserType(BillingUser.GraduateTransfer);
    }

    if (!userType && memberGroup) {
      setUserType(AccountTypeBillingTypeMap[memberGroup]);
    }
  }, [type, userType, memberGroup]);

  return userType;
}
